export default function nullifyEmptyString(
  str: string | null | undefined
): string | null {
  if (str === null || str === undefined) return null;
  return str.trim().length === 0 ? null : str;
}
